// extracted by mini-css-extract-plugin
export default {"electionsBarContainer":"electionsBarContainer-iKzmO","electionsBarNav":"electionsBarNav-GtHue","navIconElement":"navIconElement-fnZQh"};